import React from "react";
const AccessDenide = () => {
  
  return (
    <div class="container pt-5 pb-5">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="card border-danger">
                <div class="card-body text-center">
                  <h5 class="card-title text-danger">Access Denied</h5>
                  <p class="card-text">You don't have access or permission to view this page.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
};

export default AccessDenide;
